import { jsx as r } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
/* empty css               */
import { useState as g, useCallback as t } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import { CapitalOffer as k } from "../../../CapitalOffer/components/CapitalOffer/CapitalOffer.js";
import { GrantsDisplay as S } from "./GrantsDisplay.js";
import { Fragment as O } from "../../../../../external/preact/dist/preact.module.js";
const L = ({
  externalDynamicOffersConfig: n,
  grantList: i,
  newOfferAvailable: c,
  onFundsRequest: s,
  onOfferDismiss: o
}) => {
  const [f, e] = g(!1), a = t(() => e(!1), []), p = t(() => e(!0), []), l = t(() => {
    o ? o(a) : a();
  }, [a, o]), m = t(
    (u) => {
      s(u), e(!1);
    },
    [s]
  );
  return /* @__PURE__ */ r(O, { children: f ? /* @__PURE__ */ r(
    k,
    {
      externalDynamicOffersConfig: n,
      onFundsRequest: m,
      onOfferDismiss: l
    }
  ) : /* @__PURE__ */ r(S, { grantList: i, newOfferAvailable: c, onNewOfferRequest: p }) });
};
export {
  L as GrantList
};
